import { __generator } from "tslib";
import { all, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { TIERS_PER_FETCH } from '../constants';
import { getTierStreamId } from '../helpers';
function handleInitTierStream() {
    var streamId, isStreamInitialized;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                streamId = getTierStreamId();
                return [4 /*yield*/, select(selectors.isInitialized, streamId)];
            case 1:
                isStreamInitialized = _a.sent();
                if (isStreamInitialized) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, all([
                        put(withOffset.actions.initialize({
                            streamId: streamId,
                            itemsPerFetch: TIERS_PER_FETCH,
                        })),
                        put(withOffset.actions.fetch(streamId)),
                    ])];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default handleInitTierStream;
//# sourceMappingURL=initTierStream.js.map